<ingot>
  <a (click)="onLinkClick()">
    <div>
      <h2>{{ name }}</h2>
      <p><ng-content></ng-content></p>
    </div>
    <icon type="chevron-right"></icon>
  </a>
</ingot>
